
import { ReactNode, useEffect, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { CampaignResponse } from '../lib/types';
import { typedCampaign } from '../api';
import { theme } from 'shared/config/theme/theme';
import Loader from 'shared/ui/Loader/Loader';

interface Props {
	children?: ReactNode
	campaignId: string | null
}

const ThemeSettings = (props: Props) => {
	const { children, campaignId } = props;
	const [campaignData, setCampaignData] = useState<CampaignResponse | null>(null);
	const [isPending, setIsPending] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchSettings = async () => {
			if(!campaignId) return
			try {
				setIsPending(true);
				const response = await typedCampaign.getCampaignSettings(campaignId);
				setCampaignData(response.data);
			} catch (err) {
				setError(err as Error);
			} finally {
				setIsPending(false);
			}
		};
		void fetchSettings();
	}, [campaignId]);

	// Create a merged theme by combining the base theme with campaign settings
	const mergedTheme = createTheme(deepmerge(theme, { palette: campaignData?.partnerCampaign.campaign.campaignPalette ?? theme.palette }))
	return (
		<ThemeProvider theme={mergedTheme}>
			{isPending && <Loader/>}
			{!isPending && children}
		</ThemeProvider>
	);
}

export default ThemeSettings
